function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "mas_barato",
  "data-name": "mas barato",
  d: "M423,597.271a21.545,21.545,0,0,1-21.545,21.383,1.5,1.5,0,0,1,0-3.007,18.539,18.539,0,0,0,18.538-18.371l1.506-2.007Zm5.414,3.042a1.5,1.5,0,0,0,.3-2.1l-6.014-8.018a1.505,1.505,0,0,0-2.4,0l-6.013,8.018a1.5,1.5,0,1,0,2.4,1.8h0L421.5,593.6l4.81,6.414a1.5,1.5,0,0,0,2.105.3Z",
  transform: "translate(-399.953 -589.59)"
});

function SvgMasCaro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.064,
    height: 29.064,
    viewBox: "0 0 29.064 29.064",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasCaro);
export default __webpack_public_path__ + "static/media/masCaro.52af3b17.svg";
export { ForwardRef as ReactComponent };